import types from "../types";

const initial = {
  selectedPaymentMethod: null,
};

export const payment_reducer = (state = initial, { type, payload }) => {
  switch (type) {
    case types.SET_PAYMENT_METHOD:
      return {
        ...state,
        selectedPaymentMethod: payload.defaultPaymentMethod,
      };
    case types.REMOVE_PAYMENT_METHOD:
      return {
        ...state,
        selectedPaymentMethod: null,
      };
    default:
      return state;
  }
};
